// import priorityNav from 'priority-nav'
// import { Dictionary } from 'utils/Dictionary'

const Subnav = {
  el: {
    root: document.querySelector<HTMLElement>('.subnav'),
  },
  init() {
    // if (this.el.root) {
    //   /* eslint-disable */
    //   // @ts-ignore
    //   const pn = priorityNav.init({
    //     mainNavWrapper: '.subnav', // mainnav wrapper selector (must be direct parent from mainNav)
    //     mainNav: '.subnav__list', // mainnav selector. (must be inline-block)
    //     navDropdownLabel: Dictionary('subnMore'),
    //     navDropdownBreakpointLabel: Dictionary('subnMenu'),
    //     navDropdownClassName: 'subnav__dropdown', // class used for the dropdown.
    //     navDropdownToggleClassName: 'subnav__dropdown-toggle', // class used for the dropdown toggle.
    //     breakPoint: 0,
    //     // breakPoint: '780',
    //   })
    //   /* eslint-enable */
    // }
  }
}

export default Subnav
